import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import ThankYou from './ThankYou';

function Pricing() {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      e.target.reset();
      setSubmitted(true);
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return <ThankYou />;
  }

  return (
    <div className="relative bg-black text-white py-12 px-4 overflow-auto" style={{ height: '100vh' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-20 space-y-8">
          <h1 className="text-7xl font-light tracking-wider mb-6 bg-gradient-to-r from-white via-gray-200 to-gray-400 inline-block text-transparent bg-clip-text animate-fade-in">
            Connect with Orchestra
          </h1>
          <p className="text-2xl text-gray-300 max-w-3xl mx-auto font-light tracking-wider leading-relaxed">
            Harmonizing cities and businesses with real-time urban intelligence
          </p>
        </div>

        <div className="bg-black p-12 rounded-3xl shadow-2xl border border-gray-800">
          <form onSubmit={handleSubmit} className="space-y-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <label htmlFor="contact" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                  Contact Name*
                </label>
                <input
                  type="text"
                  id="contact"
                  name="contact"
                  required
                  placeholder="John Doe"
                  className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300 placeholder-gray-600"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                  Company Name*
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  required
                  placeholder="Acme Corp"
                  className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300 placeholder-gray-600"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                  Email Address*
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  placeholder="john@example.com"
                  className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300 placeholder-gray-600"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                  Phone Number <span className="text-gray-600">(Optional)</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="(123) 456-7890"
                  className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300 placeholder-gray-600"
                />
              </div>
            </div>

            <div>
              <label htmlFor="symphony" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                Reason for connecting*
              </label>
              <select
                id="symphony"
                name="symphony"
                required
                className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300"
              >
                <option value="" className="bg-gray-900">Select a reason</option>
                <option value="request-footage" className="bg-gray-900">Requesting Footage</option>
                <option value="general-inquiry" className="bg-gray-900">General Inquiry</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-3 text-gray-300 tracking-wider">
                Message <span className="text-gray-600">(Optional)</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                placeholder="How may we serve you?"
                className="w-full px-5 py-4 rounded-xl bg-gray-900 border border-gray-800 focus:outline-none focus:border-white/50 focus:ring-1 focus:ring-white/50 transition-all duration-300 placeholder-gray-600"
              ></textarea>
            </div>

            <div className="text-center pt-8">
              <button
                type="submit"
                disabled={submitting}
                className={`px-16 py-4 bg-white text-black font-medium rounded-xl 
                  transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg
                  ${submitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}
              >
                {submitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Pricing; 